module.exports = __webpack_public_path__ + "img/partner_logo07.0cdfafa5.png";